import EmoteWallWidget from '../../widgets/EmoteWallWidget';
import { tryFetch } from '../../widgetLoader';
import { RELOAD_INTERVAL } from './common';

export default async function mountEmoteWall(host) {
	const load = async () => {
		const [ settings, giftTypes ] = await Promise.all([
			host.loadSettings(),
			tryFetch(() => host.api.get(`widget/${encodeURIComponent(host.hash)}/giftTypes`), `cache-${host.hash}-giftTypes`, r => r?.results || []),
		]);
		return { settings: settings || {}, giftTypes: giftTypes || [] };
	};

	const widget = new EmoteWallWidget({
		container: host.container,
		baseUrl: process.env.VUE_APP_PIPIPUPUBASE || '',
		physics: host.physics,
	});
	await widget.init(await load());

	host.onSettingsChange(s => widget.applySettings(s));

	async function reload() {
		const d = await load();
		widget.applySettings(d.settings);
		widget.applyGiftTypes(d.giftTypes);
	}

	host.subscribe({
		reconnect: reload,
		chat: msg => {
			if(msg.sender?.isSelf) return;
			if(!msg.spans) return;
			const emotes = widget._extractEmotes(msg);
			if(emotes.length) widget.spawnEmotes(emotes);
		},
		userGiftTypeChange: data => widget.applyGiftType(data.serviceId, data.giftType, data.data),
	});

	host.every(reload, RELOAD_INTERVAL);
	host.onDestroy(() => widget.destroy());
}
